export default __webpack_public_path__ + "static/media/logout.05c758ff.svg";